"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modal_1 = require("utils/upload/modal");
var sokositeEntryAttachments_1 = require("actions/sokositeEntryAttachments");
var SokositeEntryAttachmentsUploadModal = (0, modal_1.createUploadModal)('sokositeEntryAttachments', function (state) { return state.sokositeEntryAttachments; }, sokositeEntryAttachments_1.default);
exports.default = SokositeEntryAttachmentsUploadModal;
